export const GOOGLE_TRANSLATE_ENDPOINT =
  "https://www.googleapis.com/language/translate/v2";
export const MAX_TRANSLATE_SELECTION_LENGTH = 500;
